import {Component, EventEmitter, Input, Output, Renderer2, ViewChild} from '@angular/core';
import {AchooFilterBoxComponent} from '../../../core/achoo-filter-box/achoo-filter-box.component';
import {AchooPopupComponent} from '../../../core/achoo-popup/achoo-popup.component';
import {ModalService} from '../../../services/modal/modal.service';
import {ValidationHandlerService} from '../../../core/validation-handler.service';
import {ProjectService} from '../../../services/project/project.service';
import {CommonConstant} from '../../../app.constants';
import {NgSelectComponent} from '@ng-select/ng-select';
import {UserActionType} from '../../../services/event-tracker/event-tracker.service';
import {DeviceDetectorService} from 'ngx-device-detector';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'project-selection',
  templateUrl: './project-selection.component.html',
  styleUrls: ['./project-selection.component.scss']
})
export class ProjectSelectionComponent extends AchooFilterBoxComponent {

  @ViewChild('deleteProjectWarning')
  deleteProjectWarning: AchooPopupComponent;
  @ViewChild('ngSelect')
  ngSelect: NgSelectComponent;

  @Input() allowToModifyProject = true;
  @Input() action: string;
  @Input() actionData: any;
  @Input() tooltipBox: NgbTooltip;

  @Output()
  public afterDeleteProjectEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  public editProjectEvent: EventEmitter<any> = new EventEmitter<any>();

  public selectedProject: any;

  constructor(private modalService: ModalService,
              private projectService: ProjectService,
              protected renderer: Renderer2,
              protected validationHandlerService: ValidationHandlerService,
              private deviceDetector: DeviceDetectorService) {
    super(validationHandlerService, deviceDetector, renderer);
  }

  onSelectProject(evt) {
    if (evt.id > 0) {
      super.onSelect(evt);
    }
  }

  onShowDeleteWarningPopup(evt, project) {
    evt.stopPropagation();
    this.selectedProject = project;
    this.modalService.openInCenter(this.deleteProjectWarning);
    this.ngSelect.close();
  }

  onClickProjectOption(evt, project) {
    if (project.id === 0) {
      evt.stopPropagation();
      this.editProjectEvent.emit({id: project.id, countries: []});
      this.ngSelect.close();
    }
  }

  onEditProject(evt) {
    this.editProjectEvent.emit(evt);
  }

  executeDeleteProject(e) {
    if (this.selectedProject) {
      this.modalService.close();
      this.projectService.deleteProject(this.selectedProject.id).subscribe(res => {
        this.afterDeleteProjectEvent.emit(this.selectedProject.id);
        this.hideDeletePopup();
      });
    }
  }

  private beforeDismissDeleteProjectPopup() {
    this.selectedProject = undefined;
  }

  hideDeletePopup() {
    this.beforeDismissDeleteProjectPopup();
    this.modalService.close();
  }

  getDeleteProjectName() {
    return this.selectedProject ? this.selectedProject.name : '';
  }

  getProjectActionDataByContext(isNewProject, isDeleted?: boolean) {
    if (isNewProject) {
      return Object.assign({}, this.actionData, {
        params: {
          action: UserActionType.CREATE
        }
      });
    } else if (isDeleted) {
      return Object.assign({}, this.actionData, {
        params: {
          action: UserActionType.DELETE
        }
      });
    }
    return this.actionData;
  }

  onMouseOver() {
    if (!this.tooltipBox) {
      return;
    }
    this.tooltipBox.disableTooltip = this.ngSelect.isOpen;
  }
}



// WEBPACK FOOTER //
// ./src/app/main/measure/project-selection/project-selection.component.ts